import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  TaxComplianceOverview, ComplianceActivity, ComplianceAlert,
  getOverview, getActivity, getAlerts,
} from '../services/taxComplianceApi';

interface State {
  overview: TaxComplianceOverview | null;
  activity: ComplianceActivity[];
  alerts: ComplianceAlert[];
  loading: boolean;
  error: string | null;
  fetchAll: () => Promise<void>;
}

const toErr = (e: unknown) => (e instanceof Error ? e.message : 'Something went wrong');

export const useTaxComplianceStore = create<State>()(
  devtools(
    (set) => ({
      overview: null,
      activity: [],
      alerts: [],
      loading: false,
      error: null,
      fetchAll: async () => {
        set({ loading: true, error: null });
        try {
          const [overview, activity, alerts] = await Promise.all([
            getOverview(),
            getActivity(10),
            getAlerts(),
          ]);
          set({ overview, activity, alerts, loading: false });
        } catch (err) { set({ loading: false, error: toErr(err) }); }
      },
    }),
    { name: 'tax-compliance-store' }
  )
);
